import { IonCol, IonContent, IonGrid, IonPage, IonRow } from '@ionic/react';
import { ReactElement } from 'react';
import { LoginWelcome } from '../../components/login/login-welcome';
import { Signup } from '../../components/login/signup';
import './login.css';

const SignupPage = (): ReactElement => {
  return (
    <IonPage>
      <IonContent>
        <IonGrid className="login-page-container ion-no-padding">
          <IonRow>
            <IonCol sizeMd="6" sizeXs="12" pushMd="6" pushXs="0">
              <Signup />
            </IonCol>
            <IonCol sizeMd="6" sizeXs="12" pullMd="6" pullXs="0">
              <LoginWelcome />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export { SignupPage };
